import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchProductionsWithFilters } from './store/slice';
import { fetchAllProcessStatuses } from '../../core/redux/status/slice';
import { fetchCustomers } from '../../core/redux/customer/slice';
import ProductionTopHead from './production-top-head';
import ProductionContent from './production-content';
import ProductionModals from './production-modals';
import { actions as inventoryActions } from './store/slice';
import LoadingSpinner from '../../InitialPage/Sidebar/LoadingSpinner';
import { selectProductionSubmitLoading } from './store/selectors';

const { resetFilters } = inventoryActions;

const ProductionView = () => {
  const dispatch = useDispatch();
  const isSubmitLoading = useSelector(selectProductionSubmitLoading);
  useEffect(() => {
    dispatch(fetchProductionsWithFilters());
    dispatch(fetchAllProcessStatuses());
    // dispatch(fetchCustomers({}));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return () => dispatch(resetFilters());
  }, []);

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header transfer">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Production</h4>
              </div>
            </div>
            <ProductionTopHead />
          </div>
          <ProductionContent />
          {isSubmitLoading && <LoadingSpinner />}
          <ProductionModals />
        </div>
      </div>
    </div>
  );
};

export default ProductionView;
